import React from 'react';
import { motion } from 'framer-motion';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const ThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <motion.button
      onClick={toggleTheme}
      className={`relative w-14 h-7 rounded-full p-1 transition-colors duration-300 ${
        isDark 
          ? 'bg-slate-700 border border-slate-600' 
          : 'bg-blue-100 border border-blue-200'
      } ${className}`}
      whileTap={{ scale: 0.95 }}
      data-testid="theme-toggle"
      aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
    >
      {/* Background icons */}
      <div className="absolute inset-0 flex items-center justify-between px-1.5">
        <Sun className={`w-4 h-4 transition-opacity ${isDark ? 'text-slate-500 opacity-50' : 'text-yellow-500 opacity-100'}`} />
        <Moon className={`w-4 h-4 transition-opacity ${isDark ? 'text-blue-400 opacity-100' : 'text-slate-400 opacity-50'}`} />
      </div>
      
      {/* Toggle circle */}
      <motion.div
        className={`w-5 h-5 rounded-full shadow-md flex items-center justify-center ${
          isDark ? 'bg-slate-800' : 'bg-white'
        }`}
        animate={{
          x: isDark ? 26 : 0
        }}
        transition={{ type: 'spring', stiffness: 500, damping: 30 }}
      >
        {isDark ? (
          <Moon className="w-3 h-3 text-blue-400" />
        ) : (
          <Sun className="w-3 h-3 text-yellow-500" />
        )}
      </motion.div>
    </motion.button>
  );
};

export default ThemeToggle;
